import React from 'react';
import FormItem from 'antd/es/form/FormItem';
import PropTypes from 'prop-types';
import './style.css';

const Item = (props) => {
  const { name, required, inline } = props;

  const getLabelCol = () => {
    if (inline === undefined || inline === true) return { md: 6, xs: 24 };

    return { span: 24 };
  }

  const getWrapperCol = () => {
    if (inline === undefined || inline === true) return { md: 18, xs: 24 };

    return { span: 24 };
  }
  return (
    <FormItem
      labelCol={getLabelCol()}
      wrapperCol={getWrapperCol()}
      label={inline === false ? <span style={{ marginLeft: 2, marginBottom: 5 }}>{name}</span> : name}
      required={required}
    >
      {props.children}
    </FormItem>
  );
}

export default Item;

Item.propTypes = {
  name: PropTypes.any,
  required: PropTypes.bool
};